import { Component, OnInit, OnDestroy } from '@angular/core';
import { SidenavService } from '../../services/sidenav.service';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  standalone: false,
})
export class NavBarComponent implements OnInit, OnDestroy {
  hideNav = true;

  languages = [
    { language: 'English', code: 'EN' },
    { language: 'Arabic', code: 'AR' }
  ];

  selected = this.languages[0]; // Default to English

  constructor(
    private sidenavService: SidenavService
  ) {}

  close(): void {
    this.sidenavService.toggle();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}
}
